import './Video.css';

export default function Video(props) {
    return (
        <>
            <video src={props.src} type="video/mp4" ref={props.ref}
                playsInline
                autoPlay={props.autoPlay !== undefined}
                muted={props.autoPlay !== undefined}
                controls={props.autoPlay === undefined}
                loop={props.loop !== undefined}></video>
        </>
    )
}